const CONFIG_CATEGORIES = {
  PACIENTE: `paciente`,
  COLORS: `colors`,
  INTEGRATION: `integration`,
}

const CONFIG_KEYS = {
  PACIENTE: {
    ADMIT_SOCIAL_NAME: `admitSocialName`,
  },
  COLORS: {
    TOTEM: `totem`,
    TV: `tv`,
  },
  INTEGRATION: {
    CALL_PLACE: `callPlace`,
  },
}

export { CONFIG_CATEGORIES, CONFIG_KEYS }
